// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   Cards and list rows

   Desktop cards in this app run 24–28px of padding with 20–22px titles,
   which on a 390px screen leaves roughly 330px of usable width and fits
   about one and a half cards per viewport. Mobile pulls padding to 14px and
   the title to 16px, so a card carries the same information in half the
   height.
   ════════════════════════════════════════════════════════════════════════ */

/* ── The generic card surface ───────────────────────────────────────────
   These class names are the app's recurring "panel" idiom across the
   storefront, account area and portals. Listed explicitly rather than
   matched by a wildcard so a card that needs different treatment can still
   opt out by not being in the list. */
html.m-app :is(
  .settings-panel,
  .co-panel,
  .cartpg-card,
  .oss-card,
  .pdp-benefits-card,
  .pdp-delivery-card,
  .pdp-fbt-card,
  .pdp-buyer-protection,
  .order-card,
  .dash-card,
  .kpi-card,
  .ab-card,
  .pf-card,
  .ntf-card,
  .ov-card,
  .wl-card
) {
  padding: var(--m-4);
  border-radius: var(--m-r);
  border: 1px solid var(--m-hairline);
  background: var(--m-surface-card);
  box-shadow: var(--m-shadow-sm);
  margin-bottom: var(--m-3);
}

/* Section heads inside a card: icon + title + sub. The desktop version uses
   a 44px icon chip and a 20px title; both come down a step so the head
   doesn't out-weigh the content under it. */
html.m-app .settings-section-head,
html.m-app .panel-header {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  margin-bottom: var(--m-3);
  padding-bottom: 0;
  border-bottom: none;
}

html.m-app .settings-section-head h2,
html.m-app .panel-header h2,
html.m-app .co-panel-title {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
  margin: 0;
}

html.m-app .settings-section-head p,
html.m-app .panel-header p {
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  color: var(--color-text-secondary);
  margin: 2px 0 0;
}

html.m-app .settings-section-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: var(--m-r-sm);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

html.m-app .settings-section-icon svg {
  width: var(--m-icon); height: var(--m-icon);
}

/* ════════════════════════════════════════════════════════════════════════
   Product card (.pcard)

   The storefront's densest component and the one a customer sees most. The
   desktop card carries a 21px/800 price and 13px of body padding, sized for
   a 260px-wide card in a four-up grid; in a two-up mobile grid the card is
   183px and that price is the loudest thing on the screen.

   Every element the card had is kept — image, badge, title, price,
   strikethrough, rating, seller, stock, delivery, Add to Cart. Only the
   measure changes.

   The discount RATE is deliberately absent, on mobile exactly as on the
   web: cards show the selling price and the original price struck through,
   and the rate is disclosed only in the checkout order summary. Nothing
   here reintroduces it.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .pcard-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--m-3);
  padding: 0 var(--m-gutter);
  margin: 0;
}

html.m-app .pcard {
  border-radius: var(--m-r);
  border: 1px solid var(--m-hairline);
  box-shadow: var(--m-shadow-sm);
  overflow: hidden;
}

html.m-app .pcard-body {
  padding: var(--m-3);
  gap: var(--m-1);
}

/* Reference calls for a confident title, not a caption: the product name is
   what the shopper scans, so it sits at card-title size and semibold. */
html.m-app .pcard-title {
  font-size: var(--m-fs-card-title);
  line-height: var(--m-lh-snug);
  font-weight: var(--m-fw-semibold);
  margin: 0;
}

html.m-app .pcard-title-link {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: var(--m-fs-card-title);
  line-height: var(--m-lh-snug);
  font-weight: var(--m-fw-semibold);
}

/* The price is the loudest thing on the card in the reference — a step above
   the title, tabular so a column of prices aligns. */
html.m-app .pcard-price {
  font-size: 1.25rem;
  font-weight: var(--m-fw-bold);
  line-height: 1.2;
  letter-spacing: var(--m-track-title);
  font-variant-numeric: tabular-nums;
}

html.m-app .pcard-original {
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-regular);
  color: var(--color-text-muted);
}

html.m-app .pcard-price-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--m-1) var(--m-2);
}

html.m-app :is(.pcard-review-cnt, .pcard-no-rating, .pcard-sold,
               .pcard-seller, .pcard-seller-name, .pcard-delivery,
               .pcard-verified) {
  font-size: var(--m-fs-caption);
  line-height: 1.3;
}

html.m-app .pcard-rating-badge {
  font-size: var(--m-fs-caption);
  padding: 1px var(--m-1);
  border-radius: var(--m-r-xs);
}

html.m-app .pcard-stars svg { width: 11px; height: 11px; }

html.m-app .pcard-status-pill {
  font-size: var(--m-fs-caption);
  padding: 1px var(--m-2);
  border-radius: var(--m-r-pill);
}

html.m-app .pcard-badge {
  font-size: var(--m-fs-caption);
  padding: 2px var(--m-2);
  border-radius: var(--m-r-pill);
}

/* The heart is the card's only secondary action and needs a real target;
   the desktop reveals it on hover, which touch can never trigger. */
html.m-app .pcard-heart {
  opacity: 1;
  visibility: visible;
  transform: none;
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  top: var(--m-2);
  right: var(--m-2);
  border-radius: var(--m-r-pill);
}

/* Add to Cart.

   The base rule gives this \`padding: 11px 14px\` and lets the label wrap. In
   a two-up grid the card is 150px wide at 360px viewport, so the button gets
   ~124px and "Add to Cart" needs ~96px of text plus a 14px icon — it doesn't
   fit, wraps to two (at 360px, three) lines, and the button becomes a 90px
   blue slab that outweighs the product photo it's selling.

   nowrap is the actual fix; the tighter padding and 12.5px label are what
   make nowrap fit down to a 320px screen. Height drops to 38px so the
   primary action still reads as primary without dominating the card. */
html.m-app .pcard-add-cart-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--m-1);
  width: 100%;
  min-height: var(--m-touch);
  padding: 0 var(--m-2);
  font-size: 0.8125rem;
  font-weight: var(--m-fw-semibold);
  line-height: 1;
  letter-spacing: 0;
  border-radius: var(--m-r-sm);
  /* The load-bearing property. Without it the label breaks after "Add to"
     and the button becomes a two- or three-line slab taller than the photo
     it sits under. Everything else here is sized so nowrap actually fits a
     150px card at a 360px viewport. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Restated because App.css sets these on .pcard-add-cart-btn inside its own
   @media block, which would otherwise re-inflate the button. */
html.m-app .pcard-add-cart-btn {
  min-height: var(--m-touch);
  padding: 0 var(--m-2);
  margin-top: var(--m-2);
}

html.m-app .pcard-add-cart-btn svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
}

/* Tighten the text stack above it: title, rating and price were spaced for
   a card half again as tall. */
html.m-app .pcard-body {
  gap: var(--m-1);
  padding: var(--m-3);
}

html.m-app .pcard-rating-row {
  gap: var(--m-1);
  margin: 0;
}

html.m-app .pcard-price-row {
  margin-top: 0;
}

html.m-app .pcard-img-wrap { aspect-ratio: 1 / 1; }

/* ════════════════════════════════════════════════════════════════════════
   Category carousel card (.cat-carousel-card)

   The homepage's horizontal product rails use a second, narrower card
   (138px) that shares none of .pcard's class names. Same treatment.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .cat-carousel-track {
  gap: var(--m-3);
  padding: var(--m-1) var(--m-gutter) var(--m-2);
}

/* Top Sales wears the same card as "Great finds for you".
   
   These were two different-looking components doing the same job on one
   screen: the rail drew a raised white card with a square-cornered image
   and 13px/16px type, while the feed grid below it drew no card at all --
   a rounded image tile on the page, an 11px name and a 13px price, with
   the rating over the image. Stacked vertically the rail read as heavier
   and older than the section under it.
   
   The rail keeps being a rail -- horizontal, snapping, dotted. Only the
   card treatment is taken from .mf-card, tile for tile. */
html.m-app .cat-carousel-card {
  /* One third of the content width, so a rail card lands on exactly the
     same column as a grid card in the section below it. */
  flex: 0 0 calc((100vw - (var(--m-gutter) * 2) - (var(--m-2) * 2)) / 3);
  /* Without this the flex basis above is only a suggestion: a flex item's
     min-width is \`auto\`, so the nowrap product name's min-content width wins
     and the card grows to fit the whole title on one line -- "Fitbit Sense 2
     Advanced Smartwatch" was rendering a 285px card in a 108px slot.
     .mf-card carries the same declaration for the same reason. */
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--m-1);
  background: none;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

html.m-app .cat-carousel-card:active { opacity: 0.7; }

html.m-app .cat-carousel-card-img-wrap {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  /* The wrap is a flex item, so its min-height is \`auto\` -- content is
     allowed to push it past the aspect ratio. That is what happened: the
     image's \`height: 100%\` resolves against a parent whose own height comes
     from aspect-ratio, which counts as auto, so a portrait source rendered
     at its intrinsic height and dragged the tile with it. Card content
     heights ranged 169-346px and align-items:stretch levelled every card in
     the rail to the tallest one. */
  flex: 0 0 auto;
  min-height: 0;
  border-radius: var(--m-r-sm);
  overflow: hidden;
  background: var(--m-surface-sunken);
}

/* Taking the image out of flow is what makes the square unconditional: the
   tile's height then comes from aspect-ratio alone and no source image can
   argue with it. */
html.m-app .cat-carousel-card-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

html.m-app .cat-carousel-card-body {
  /* The card supplies the gap now; the body is just the text stack. */
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--m-1);
  padding: 0;
  min-width: 0;
}

html.m-app .cat-carousel-card-name {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-regular);
  line-height: var(--m-lh-snug);
  color: var(--color-text-secondary);
  /* One line, as in the grid: a wrapping name makes the rail ragged and
     pushes the price out of line across the visible cards.
     
     The base rule clamps to two lines with display:-webkit-box plus a
     min-height of 2.3em that reserves the second line whether or not it is
     used. Both have to go, or the name keeps a 25px box against the grid's
     15px and every rail card sits 10px taller than its grid twin. */
  display: block;
  -webkit-line-clamp: none;
  min-height: 0;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* The name is a <p> wrapping a crawlable <Link>. .pcard-title-link carries
   its own 16px/21.6px type, so the paragraph came out 22px tall against the
   grid's 15px however the <p> itself was styled -- the inner link has to
   inherit, not just be told to ellipsis. */
html.m-app .cat-carousel-card-name .pcard-title-link {
  display: block;
  font: inherit;
  line-height: inherit;
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

html.m-app .cat-carousel-card-price {
  display: flex;
  align-items: baseline;
  gap: var(--m-1);
  min-width: 0;
}

html.m-app .cat-carousel-price,
html.m-app .cat-carousel-price-sale {
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-bold);
  font-variant-numeric: tabular-nums;
}

html.m-app .cat-carousel-price-was {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
  text-decoration: line-through;
  font-variant-numeric: tabular-nums;
}

/* The pill moves over the image, bottom-left, exactly as .mf-card-rating
   sits. No markup change is needed: .cat-carousel-card-body's top edge IS
   the image's bottom edge, so \`bottom: 100%\` parks the row on that seam and
   the margin lifts it back inside the picture. */
html.m-app .cat-carousel-card-rating-row {
  position: absolute;
  bottom: 100%;
  left: var(--m-1);
  margin-bottom: var(--m-1);
  z-index: 1;
}

/* The grid shows the pill alone -- the count and the "No reviews" placeholder
   are legible under a name, not over a photograph. */
html.m-app :is(.cat-carousel-review-cnt, .cat-carousel-no-rating) {
  display: none;
}

html.m-app .cat-carousel-rating-pill {
  font-size: var(--m-fs-caption);
  padding: 1px var(--m-1);
}

html.m-app .cat-carousel-badge {
  font-size: var(--m-fs-caption);
  padding: 2px var(--m-2);
  border-radius: var(--m-r-pill);
}

/* Quick-view is a hover affordance with no touch equivalent; the card
   itself opens the product. */
html.m-app .cat-carousel-quickview { display: none; }

/* ── Generic product card (other surfaces) ──────────────────────────────
   The storefront's densest component. On mobile it holds a 22px title and a
   26px price, so two cards side by side wrapped onto four lines each. The
   card keeps every element it had — image, title, price, was-price, rating,
   swatches, stock, cart button — just at phone measure.

   Note the discount rate stays absent here: product cards show price and
   strikethrough only, and the rate is disclosed solely in the checkout
   order summary. Nothing below reintroduces it. */
html.m-app .product-card {
  border-radius: var(--m-r);
  border: 1px solid var(--m-hairline);
  box-shadow: var(--m-shadow-sm);
  overflow: hidden;
}

html.m-app .card-body {
  padding: var(--m-3);
  gap: var(--m-1);
}

html.m-app .card-title {
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-medium);
  line-height: var(--m-lh-snug);
  /* Two lines then ellipsis: a fixed title height is what keeps a grid of
     cards from turning into a ragged staircase. */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(var(--m-fs-secondary) * var(--m-lh-snug) * 2);
  margin: 0;
}

html.m-app .card-price {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-bold);
  line-height: 1.2;
  letter-spacing: var(--m-track-title);
  font-variant-numeric: tabular-nums;
}

html.m-app .card-mrp {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
  text-decoration: line-through;
}

html.m-app .card-price-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--m-1) var(--m-2);
  margin-top: var(--m-1);
}

html.m-app .card-meta-row {
  gap: var(--m-1) var(--m-2);
  margin-top: var(--m-1);
}

/* Rating: the one sanctioned green, kept intact — just sized for the card. */
html.m-app .card-rating-pill {
  font-size: var(--m-fs-caption);
  padding: 2px var(--m-2);
  border-radius: var(--m-r-pill);
  gap: 3px;
}

html.m-app .card-review-cnt,
html.m-app .card-review-count,
html.m-app .card-no-rating {
  font-size: var(--m-fs-caption);
}

html.m-app .card-stars svg {
  width: 12px; height: 12px;
}

/* The add-to-cart control on a card is a real touch target, not a hover
   reveal — @media (hover: none) means a hover-only button is unreachable. */
html.m-app .card-cart-btn {
  min-height: var(--m-touch);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-semibold);
  opacity: 1;
  transform: none;
  visibility: visible;
  position: static;
  width: 100%;
  margin-top: var(--m-2);
}

/* Hover-only affordances have no touch equivalent; the same actions are
   reachable from the product page. */
html.m-app .card-hover-section,
html.m-app .card-compare {
  display: none;
}

/* Wishlist heart stays, as a proper 40px tap target in the image corner. */
html.m-app .card-wishlist {
  opacity: 1;
  visibility: visible;
  transform: none;
  width: 36px;
  height: 36px;
  min-height: 36px;
  min-width: 36px;
  top: var(--m-2);
  right: var(--m-2);
  border-radius: var(--m-r-pill);
  background: color-mix(in srgb, var(--color-brand-white) 88%, transparent);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: var(--m-shadow-sm);
}

html.m-app .card-img-wrap {
  border-radius: 0;
  aspect-ratio: 1 / 1;
}

html.m-app .card-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

html.m-app .card-stock-ribbon,
html.m-app .card-off {
  font-size: var(--m-fs-caption);
  padding: 2px var(--m-2);
  border-radius: var(--m-r-pill);
}

html.m-app .card-swatches {
  gap: var(--m-1);
  margin-top: var(--m-1);
}

html.m-app .card-swatches > * {
  width: 14px;
  height: 14px;
}

/* ── Product grid ───────────────────────────────────────────────────────
   Two columns with a 12px gutter is the density a phone store wants: big
   enough to judge a photo, tight enough that four products are visible at
   once. */
html.m-app .product-grid,
html.m-app .products-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--m-3);
  padding: 0 var(--m-gutter);
  margin: 0;
}

/* ── List rows ──────────────────────────────────────────────────────────
   The pattern that replaces table rows and oversized cards: leading icon or
   thumbnail, a title/subtitle stack, a trailing value or chevron. One tap
   target, one primary action, secondary actions in an overflow menu. */
html.m-app .m-row {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  width: 100%;
  min-height: 56px;
  padding: var(--m-3) var(--m-4);
  background: var(--m-surface-card);
  border: none;
  border-bottom: 1px solid var(--m-hairline);
  text-align: left;
  color: inherit;
}

html.m-app .m-row:last-child { border-bottom: none; }
html.m-app .m-row:active { background: var(--color-surface-hover); }

html.m-app .m-row-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

html.m-app .m-row-title {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-medium);
  line-height: var(--m-lh-snug);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

html.m-app .m-row-sub {
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
  line-height: var(--m-lh-snug);
}

html.m-app .m-row-value {
  flex: 0 0 auto;
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  font-variant-numeric: tabular-nums;
}

html.m-app .m-row-chevron {
  flex: 0 0 auto;
  color: var(--color-text-muted);
  display: inline-flex;
}

/* A group of rows reads as one card. */
html.m-app .m-row-group {
  border: 1px solid var(--m-hairline);
  border-radius: var(--m-r);
  overflow: hidden;
  background: var(--m-surface-card);
  box-shadow: var(--m-shadow-sm);
  margin-bottom: var(--m-4);
}

/* ── Collapsible section ────────────────────────────────────────────────
   Progressive disclosure: summary visible, detail one tap away. Uses
   <details>/<summary> so it works without JS and stays keyboard-operable. */
html.m-app .m-collapse {
  border: 1px solid var(--m-hairline);
  border-radius: var(--m-r);
  background: var(--m-surface-card);
  overflow: hidden;
  margin-bottom: var(--m-3);
}

html.m-app .m-collapse > summary {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  min-height: var(--m-control);
  padding: var(--m-3) var(--m-4);
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  cursor: pointer;
  list-style: none;
}

html.m-app .m-collapse > summary::-webkit-details-marker { display: none; }

html.m-app .m-collapse > summary::after {
  content: '';
  margin-left: auto;
  width: 8px;
  height: 8px;
  border-right: 2px solid var(--color-text-muted);
  border-bottom: 2px solid var(--color-text-muted);
  transform: rotate(45deg) translateY(-2px);
  transition: transform var(--m-dur) var(--m-ease);
}

html.m-app .m-collapse[open] > summary::after {
  transform: rotate(-135deg) translateY(-2px);
}

html.m-app .m-collapse > summary:active { background: var(--color-surface-hover); }

html.m-app .m-collapse-body {
  padding: 0 var(--m-4) var(--m-4);
  border-top: 1px solid var(--m-hairline);
  padding-top: var(--m-3);
}
`, "",{"version":3,"sources":["webpack://./src/mobile/cards.css"],"names":[],"mappings":"AAAA;;;;;;;;6EAQ6E;;AAE7E;;;;sCAIsC;AACtC;;;;;;;;;;;;;;;;;;EAkBE,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;4CAE4C;AAC5C;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,iCAAiC;EACjC,iCAAiC;EACjC,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;EAEE,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB,EAAE,qBAAqB;AAC7C;;AAEA;;;;;;;;;;;;;;;;6EAgB6E;;AAE7E;EACE,aAAa;EACb,gDAAgD;EAChD,eAAe;EACf,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;wEACwE;AACxE;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;qDACqD;AACrD;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;;EAGE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,8BAA8B,WAAW,EAAE,YAAY,EAAE;;AAEzD;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;oEACoE;AACpE;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;;;;;;;;;uEAUuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B;;;sCAGoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;+DAC+D;AAC/D;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;+BAC+B;AAC/B;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD;;;;;6EAK6E;;AAE7E;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;;;;;;;;;;0DAU0D;AAC1D;EACE;0DACwD;EACxD,sEAAsE;EACtE;;;;iEAI+D;EAC/D,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,uCAAuC,YAAY,EAAE;;AAErD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB;;;;;;mCAMiC;EACjC,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;mBAEmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;EAClC;;;;;;oEAMkE;EAClE,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;2CAG2C;AAC3C;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;;iDAGiD;AACjD;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;qDACqD;AACrD;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;8BAC8B;AAC9B,qCAAqC,aAAa,EAAE;;AAEpD;;;;;;;;kDAQkD;AAClD;EACE,yBAAyB;EACzB,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;EAC7B;kDACgD;EAChD,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,8DAA8D;EAC9D,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,WAAW,EAAE,YAAY;AAC3B;;AAEA;4EAC4E;AAC5E;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;EACjC,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;qCACqC;AACrC;;EAEE,aAAa;AACf;;AAEA,2EAA2E;AAC3E;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,yEAAyE;EACzE,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;UAGU;AACV;;EAEE,aAAa;EACb,gDAAgD;EAChD,eAAe;EACf,0BAA0B;EAC1B,SAAS;AACX;;AAEA;;;uEAGuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;EACjC,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B,mBAAmB,EAAE;AACpD,2BAA2B,sCAAsC,EAAE;;AAEnE;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;4EAE4E;AAC5E;EACE,mCAAmC;EACnC,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA,2DAA2D,aAAa,EAAE;;AAE1E;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,+CAA+C;EAC/C,gDAAgD;EAChD,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,0CAA0C,sCAAsC,EAAE;;AAElF;EACE,gCAAgC;EAChC,uCAAuC;EACvC,uBAAuB;AACzB","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   Cards and list rows\n\n   Desktop cards in this app run 24–28px of padding with 20–22px titles,\n   which on a 390px screen leaves roughly 330px of usable width and fits\n   about one and a half cards per viewport. Mobile pulls padding to 14px and\n   the title to 16px, so a card carries the same information in half the\n   height.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* ── The generic card surface ───────────────────────────────────────────\n   These class names are the app's recurring \"panel\" idiom across the\n   storefront, account area and portals. Listed explicitly rather than\n   matched by a wildcard so a card that needs different treatment can still\n   opt out by not being in the list. */\nhtml.m-app :is(\n  .settings-panel,\n  .co-panel,\n  .cartpg-card,\n  .oss-card,\n  .pdp-benefits-card,\n  .pdp-delivery-card,\n  .pdp-fbt-card,\n  .pdp-buyer-protection,\n  .order-card,\n  .dash-card,\n  .kpi-card,\n  .ab-card,\n  .pf-card,\n  .ntf-card,\n  .ov-card,\n  .wl-card\n) {\n  padding: var(--m-4);\n  border-radius: var(--m-r);\n  border: 1px solid var(--m-hairline);\n  background: var(--m-surface-card);\n  box-shadow: var(--m-shadow-sm);\n  margin-bottom: var(--m-3);\n}\n\n/* Section heads inside a card: icon + title + sub. The desktop version uses\n   a 44px icon chip and a 20px title; both come down a step so the head\n   doesn't out-weigh the content under it. */\nhtml.m-app .settings-section-head,\nhtml.m-app .panel-header {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  margin-bottom: var(--m-3);\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\nhtml.m-app .settings-section-head h2,\nhtml.m-app .panel-header h2,\nhtml.m-app .co-panel-title {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n  margin: 0;\n}\n\nhtml.m-app .settings-section-head p,\nhtml.m-app .panel-header p {\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-secondary);\n  margin: 2px 0 0;\n}\n\nhtml.m-app .settings-section-icon {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: var(--m-r-sm);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n\nhtml.m-app .settings-section-icon svg {\n  width: var(--m-icon); height: var(--m-icon);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Product card (.pcard)\n\n   The storefront's densest component and the one a customer sees most. The\n   desktop card carries a 21px/800 price and 13px of body padding, sized for\n   a 260px-wide card in a four-up grid; in a two-up mobile grid the card is\n   183px and that price is the loudest thing on the screen.\n\n   Every element the card had is kept — image, badge, title, price,\n   strikethrough, rating, seller, stock, delivery, Add to Cart. Only the\n   measure changes.\n\n   The discount RATE is deliberately absent, on mobile exactly as on the\n   web: cards show the selling price and the original price struck through,\n   and the rate is disclosed only in the checkout order summary. Nothing\n   here reintroduces it.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .pcard-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--m-3);\n  padding: 0 var(--m-gutter);\n  margin: 0;\n}\n\nhtml.m-app .pcard {\n  border-radius: var(--m-r);\n  border: 1px solid var(--m-hairline);\n  box-shadow: var(--m-shadow-sm);\n  overflow: hidden;\n}\n\nhtml.m-app .pcard-body {\n  padding: var(--m-3);\n  gap: var(--m-1);\n}\n\n/* Reference calls for a confident title, not a caption: the product name is\n   what the shopper scans, so it sits at card-title size and semibold. */\nhtml.m-app .pcard-title {\n  font-size: var(--m-fs-card-title);\n  line-height: var(--m-lh-snug);\n  font-weight: var(--m-fw-semibold);\n  margin: 0;\n}\n\nhtml.m-app .pcard-title-link {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: var(--m-fs-card-title);\n  line-height: var(--m-lh-snug);\n  font-weight: var(--m-fw-semibold);\n}\n\n/* The price is the loudest thing on the card in the reference — a step above\n   the title, tabular so a column of prices aligns. */\nhtml.m-app .pcard-price {\n  font-size: 1.25rem;\n  font-weight: var(--m-fw-bold);\n  line-height: 1.2;\n  letter-spacing: var(--m-track-title);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .pcard-original {\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-regular);\n  color: var(--color-text-muted);\n}\n\nhtml.m-app .pcard-price-row {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: var(--m-1) var(--m-2);\n}\n\nhtml.m-app :is(.pcard-review-cnt, .pcard-no-rating, .pcard-sold,\n               .pcard-seller, .pcard-seller-name, .pcard-delivery,\n               .pcard-verified) {\n  font-size: var(--m-fs-caption);\n  line-height: 1.3;\n}\n\nhtml.m-app .pcard-rating-badge {\n  font-size: var(--m-fs-caption);\n  padding: 1px var(--m-1);\n  border-radius: var(--m-r-xs);\n}\n\nhtml.m-app .pcard-stars svg { width: 11px; height: 11px; }\n\nhtml.m-app .pcard-status-pill {\n  font-size: var(--m-fs-caption);\n  padding: 1px var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\nhtml.m-app .pcard-badge {\n  font-size: var(--m-fs-caption);\n  padding: 2px var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\n/* The heart is the card's only secondary action and needs a real target;\n   the desktop reveals it on hover, which touch can never trigger. */\nhtml.m-app .pcard-heart {\n  opacity: 1;\n  visibility: visible;\n  transform: none;\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  min-height: 34px;\n  top: var(--m-2);\n  right: var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\n/* Add to Cart.\n\n   The base rule gives this `padding: 11px 14px` and lets the label wrap. In\n   a two-up grid the card is 150px wide at 360px viewport, so the button gets\n   ~124px and \"Add to Cart\" needs ~96px of text plus a 14px icon — it doesn't\n   fit, wraps to two (at 360px, three) lines, and the button becomes a 90px\n   blue slab that outweighs the product photo it's selling.\n\n   nowrap is the actual fix; the tighter padding and 12.5px label are what\n   make nowrap fit down to a 320px screen. Height drops to 38px so the\n   primary action still reads as primary without dominating the card. */\nhtml.m-app .pcard-add-cart-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--m-1);\n  width: 100%;\n  min-height: var(--m-touch);\n  padding: 0 var(--m-2);\n  font-size: 0.8125rem;\n  font-weight: var(--m-fw-semibold);\n  line-height: 1;\n  letter-spacing: 0;\n  border-radius: var(--m-r-sm);\n  /* The load-bearing property. Without it the label breaks after \"Add to\"\n     and the button becomes a two- or three-line slab taller than the photo\n     it sits under. Everything else here is sized so nowrap actually fits a\n     150px card at a 360px viewport. */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Restated because App.css sets these on .pcard-add-cart-btn inside its own\n   @media block, which would otherwise re-inflate the button. */\nhtml.m-app .pcard-add-cart-btn {\n  min-height: var(--m-touch);\n  padding: 0 var(--m-2);\n  margin-top: var(--m-2);\n}\n\nhtml.m-app .pcard-add-cart-btn svg {\n  width: 15px;\n  height: 15px;\n  flex: 0 0 auto;\n}\n\n/* Tighten the text stack above it: title, rating and price were spaced for\n   a card half again as tall. */\nhtml.m-app .pcard-body {\n  gap: var(--m-1);\n  padding: var(--m-3);\n}\n\nhtml.m-app .pcard-rating-row {\n  gap: var(--m-1);\n  margin: 0;\n}\n\nhtml.m-app .pcard-price-row {\n  margin-top: 0;\n}\n\nhtml.m-app .pcard-img-wrap { aspect-ratio: 1 / 1; }\n\n/* ════════════════════════════════════════════════════════════════════════\n   Category carousel card (.cat-carousel-card)\n\n   The homepage's horizontal product rails use a second, narrower card\n   (138px) that shares none of .pcard's class names. Same treatment.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .cat-carousel-track {\n  gap: var(--m-3);\n  padding: var(--m-1) var(--m-gutter) var(--m-2);\n}\n\n/* Top Sales wears the same card as \"Great finds for you\".\n   \n   These were two different-looking components doing the same job on one\n   screen: the rail drew a raised white card with a square-cornered image\n   and 13px/16px type, while the feed grid below it drew no card at all --\n   a rounded image tile on the page, an 11px name and a 13px price, with\n   the rating over the image. Stacked vertically the rail read as heavier\n   and older than the section under it.\n   \n   The rail keeps being a rail -- horizontal, snapping, dotted. Only the\n   card treatment is taken from .mf-card, tile for tile. */\nhtml.m-app .cat-carousel-card {\n  /* One third of the content width, so a rail card lands on exactly the\n     same column as a grid card in the section below it. */\n  flex: 0 0 calc((100vw - (var(--m-gutter) * 2) - (var(--m-2) * 2)) / 3);\n  /* Without this the flex basis above is only a suggestion: a flex item's\n     min-width is `auto`, so the nowrap product name's min-content width wins\n     and the card grows to fit the whole title on one line -- \"Fitbit Sense 2\n     Advanced Smartwatch\" was rendering a 285px card in a 108px slot.\n     .mf-card carries the same declaration for the same reason. */\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-1);\n  background: none;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  overflow: visible;\n}\n\nhtml.m-app .cat-carousel-card:active { opacity: 0.7; }\n\nhtml.m-app .cat-carousel-card-img-wrap {\n  position: relative;\n  display: block;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  /* The wrap is a flex item, so its min-height is `auto` -- content is\n     allowed to push it past the aspect ratio. That is what happened: the\n     image's `height: 100%` resolves against a parent whose own height comes\n     from aspect-ratio, which counts as auto, so a portrait source rendered\n     at its intrinsic height and dragged the tile with it. Card content\n     heights ranged 169-346px and align-items:stretch levelled every card in\n     the rail to the tallest one. */\n  flex: 0 0 auto;\n  min-height: 0;\n  border-radius: var(--m-r-sm);\n  overflow: hidden;\n  background: var(--m-surface-sunken);\n}\n\n/* Taking the image out of flow is what makes the square unconditional: the\n   tile's height then comes from aspect-ratio alone and no source image can\n   argue with it. */\nhtml.m-app .cat-carousel-card-img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\nhtml.m-app .cat-carousel-card-body {\n  /* The card supplies the gap now; the body is just the text stack. */\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-1);\n  padding: 0;\n  min-width: 0;\n}\n\nhtml.m-app .cat-carousel-card-name {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-regular);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-secondary);\n  /* One line, as in the grid: a wrapping name makes the rail ragged and\n     pushes the price out of line across the visible cards.\n     \n     The base rule clamps to two lines with display:-webkit-box plus a\n     min-height of 2.3em that reserves the second line whether or not it is\n     used. Both have to go, or the name keeps a 25px box against the grid's\n     15px and every rail card sits 10px taller than its grid twin. */\n  display: block;\n  -webkit-line-clamp: none;\n  min-height: 0;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* The name is a <p> wrapping a crawlable <Link>. .pcard-title-link carries\n   its own 16px/21.6px type, so the paragraph came out 22px tall against the\n   grid's 15px however the <p> itself was styled -- the inner link has to\n   inherit, not just be told to ellipsis. */\nhtml.m-app .cat-carousel-card-name .pcard-title-link {\n  display: block;\n  font: inherit;\n  line-height: inherit;\n  color: inherit;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nhtml.m-app .cat-carousel-card-price {\n  display: flex;\n  align-items: baseline;\n  gap: var(--m-1);\n  min-width: 0;\n}\n\nhtml.m-app .cat-carousel-price,\nhtml.m-app .cat-carousel-price-sale {\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-bold);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .cat-carousel-price-was {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n  text-decoration: line-through;\n  font-variant-numeric: tabular-nums;\n}\n\n/* The pill moves over the image, bottom-left, exactly as .mf-card-rating\n   sits. No markup change is needed: .cat-carousel-card-body's top edge IS\n   the image's bottom edge, so `bottom: 100%` parks the row on that seam and\n   the margin lifts it back inside the picture. */\nhtml.m-app .cat-carousel-card-rating-row {\n  position: absolute;\n  bottom: 100%;\n  left: var(--m-1);\n  margin-bottom: var(--m-1);\n  z-index: 1;\n}\n\n/* The grid shows the pill alone -- the count and the \"No reviews\" placeholder\n   are legible under a name, not over a photograph. */\nhtml.m-app :is(.cat-carousel-review-cnt, .cat-carousel-no-rating) {\n  display: none;\n}\n\nhtml.m-app .cat-carousel-rating-pill {\n  font-size: var(--m-fs-caption);\n  padding: 1px var(--m-1);\n}\n\nhtml.m-app .cat-carousel-badge {\n  font-size: var(--m-fs-caption);\n  padding: 2px var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\n/* Quick-view is a hover affordance with no touch equivalent; the card\n   itself opens the product. */\nhtml.m-app .cat-carousel-quickview { display: none; }\n\n/* ── Generic product card (other surfaces) ──────────────────────────────\n   The storefront's densest component. On mobile it holds a 22px title and a\n   26px price, so two cards side by side wrapped onto four lines each. The\n   card keeps every element it had — image, title, price, was-price, rating,\n   swatches, stock, cart button — just at phone measure.\n\n   Note the discount rate stays absent here: product cards show price and\n   strikethrough only, and the rate is disclosed solely in the checkout\n   order summary. Nothing below reintroduces it. */\nhtml.m-app .product-card {\n  border-radius: var(--m-r);\n  border: 1px solid var(--m-hairline);\n  box-shadow: var(--m-shadow-sm);\n  overflow: hidden;\n}\n\nhtml.m-app .card-body {\n  padding: var(--m-3);\n  gap: var(--m-1);\n}\n\nhtml.m-app .card-title {\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-medium);\n  line-height: var(--m-lh-snug);\n  /* Two lines then ellipsis: a fixed title height is what keeps a grid of\n     cards from turning into a ragged staircase. */\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: calc(var(--m-fs-secondary) * var(--m-lh-snug) * 2);\n  margin: 0;\n}\n\nhtml.m-app .card-price {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-bold);\n  line-height: 1.2;\n  letter-spacing: var(--m-track-title);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .card-mrp {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n  text-decoration: line-through;\n}\n\nhtml.m-app .card-price-row {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: var(--m-1) var(--m-2);\n  margin-top: var(--m-1);\n}\n\nhtml.m-app .card-meta-row {\n  gap: var(--m-1) var(--m-2);\n  margin-top: var(--m-1);\n}\n\n/* Rating: the one sanctioned green, kept intact — just sized for the card. */\nhtml.m-app .card-rating-pill {\n  font-size: var(--m-fs-caption);\n  padding: 2px var(--m-2);\n  border-radius: var(--m-r-pill);\n  gap: 3px;\n}\n\nhtml.m-app .card-review-cnt,\nhtml.m-app .card-review-count,\nhtml.m-app .card-no-rating {\n  font-size: var(--m-fs-caption);\n}\n\nhtml.m-app .card-stars svg {\n  width: 12px; height: 12px;\n}\n\n/* The add-to-cart control on a card is a real touch target, not a hover\n   reveal — @media (hover: none) means a hover-only button is unreachable. */\nhtml.m-app .card-cart-btn {\n  min-height: var(--m-touch);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-semibold);\n  opacity: 1;\n  transform: none;\n  visibility: visible;\n  position: static;\n  width: 100%;\n  margin-top: var(--m-2);\n}\n\n/* Hover-only affordances have no touch equivalent; the same actions are\n   reachable from the product page. */\nhtml.m-app .card-hover-section,\nhtml.m-app .card-compare {\n  display: none;\n}\n\n/* Wishlist heart stays, as a proper 40px tap target in the image corner. */\nhtml.m-app .card-wishlist {\n  opacity: 1;\n  visibility: visible;\n  transform: none;\n  width: 36px;\n  height: 36px;\n  min-height: 36px;\n  min-width: 36px;\n  top: var(--m-2);\n  right: var(--m-2);\n  border-radius: var(--m-r-pill);\n  background: color-mix(in srgb, var(--color-brand-white) 88%, transparent);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app .card-img-wrap {\n  border-radius: 0;\n  aspect-ratio: 1 / 1;\n}\n\nhtml.m-app .card-img-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\nhtml.m-app .card-stock-ribbon,\nhtml.m-app .card-off {\n  font-size: var(--m-fs-caption);\n  padding: 2px var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\nhtml.m-app .card-swatches {\n  gap: var(--m-1);\n  margin-top: var(--m-1);\n}\n\nhtml.m-app .card-swatches > * {\n  width: 14px;\n  height: 14px;\n}\n\n/* ── Product grid ───────────────────────────────────────────────────────\n   Two columns with a 12px gutter is the density a phone store wants: big\n   enough to judge a photo, tight enough that four products are visible at\n   once. */\nhtml.m-app .product-grid,\nhtml.m-app .products-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--m-3);\n  padding: 0 var(--m-gutter);\n  margin: 0;\n}\n\n/* ── List rows ──────────────────────────────────────────────────────────\n   The pattern that replaces table rows and oversized cards: leading icon or\n   thumbnail, a title/subtitle stack, a trailing value or chevron. One tap\n   target, one primary action, secondary actions in an overflow menu. */\nhtml.m-app .m-row {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  width: 100%;\n  min-height: 56px;\n  padding: var(--m-3) var(--m-4);\n  background: var(--m-surface-card);\n  border: none;\n  border-bottom: 1px solid var(--m-hairline);\n  text-align: left;\n  color: inherit;\n}\n\nhtml.m-app .m-row:last-child { border-bottom: none; }\nhtml.m-app .m-row:active { background: var(--color-surface-hover); }\n\nhtml.m-app .m-row-main {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\nhtml.m-app .m-row-title {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-medium);\n  line-height: var(--m-lh-snug);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nhtml.m-app .m-row-sub {\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .m-row-value {\n  flex: 0 0 auto;\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .m-row-chevron {\n  flex: 0 0 auto;\n  color: var(--color-text-muted);\n  display: inline-flex;\n}\n\n/* A group of rows reads as one card. */\nhtml.m-app .m-row-group {\n  border: 1px solid var(--m-hairline);\n  border-radius: var(--m-r);\n  overflow: hidden;\n  background: var(--m-surface-card);\n  box-shadow: var(--m-shadow-sm);\n  margin-bottom: var(--m-4);\n}\n\n/* ── Collapsible section ────────────────────────────────────────────────\n   Progressive disclosure: summary visible, detail one tap away. Uses\n   <details>/<summary> so it works without JS and stays keyboard-operable. */\nhtml.m-app .m-collapse {\n  border: 1px solid var(--m-hairline);\n  border-radius: var(--m-r);\n  background: var(--m-surface-card);\n  overflow: hidden;\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .m-collapse > summary {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  min-height: var(--m-control);\n  padding: var(--m-3) var(--m-4);\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  cursor: pointer;\n  list-style: none;\n}\n\nhtml.m-app .m-collapse > summary::-webkit-details-marker { display: none; }\n\nhtml.m-app .m-collapse > summary::after {\n  content: '';\n  margin-left: auto;\n  width: 8px;\n  height: 8px;\n  border-right: 2px solid var(--color-text-muted);\n  border-bottom: 2px solid var(--color-text-muted);\n  transform: rotate(45deg) translateY(-2px);\n  transition: transform var(--m-dur) var(--m-ease);\n}\n\nhtml.m-app .m-collapse[open] > summary::after {\n  transform: rotate(-135deg) translateY(-2px);\n}\n\nhtml.m-app .m-collapse > summary:active { background: var(--color-surface-hover); }\n\nhtml.m-app .m-collapse-body {\n  padding: 0 var(--m-4) var(--m-4);\n  border-top: 1px solid var(--m-hairline);\n  padding-top: var(--m-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
